import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  DateTimeFilter,
  GroupedSearchFilterFacet,
  QueryableFilter,
  SearchFilterFacet,
  SortOption,
} from '@savgroup-front-common/types';

import {
  EXPORT_FORMAT,
  SelectedColumnForExport,
} from './exportFilteredFilesCommand';

const ENDPOINT = `${APIConfiguration.search}export/filteredStockItems`;

export interface ExportFilteredStockItemsCommandArgs {
  query?: string;
  exportFormat: EXPORT_FORMAT;
  filters?: SearchFilterFacet[];
  groupedFilters?: GroupedSearchFilterFacet[];
  dateTimeFilters?: DateTimeFilter[];
  queryableFilters?: QueryableFilter[];
  sortOptions?: SortOption[];
  selectedColumns?: SelectedColumnForExport[];
  sellerId?: string;
  tenantId?: string;
}

async function exportFilteredStockItemsCommand({
  exportFormat,
  query,
  filters,
  groupedFilters,
  dateTimeFilters,
  queryableFilters,
  sortOptions,
  selectedColumns,
  sellerId,
  tenantId,
}: ExportFilteredStockItemsCommandArgs): Promise<
  BackResponse<string> | BackResponseFailure
> {
  try {
    return await apiCall<BackResponse<string>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        query,
        filters,
        groupedFilters,
        dateTimeFilters,
        queryableFilters,
        exportFormat,
        sortOptions,
        selectedColumns,
        sellerId,
        tenantId,
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default exportFilteredStockItemsCommand;
